import pesquisaSatisfacaoHttpService from '../_services/pesquisaSatisfacaoHttpService'
import { GET_ALL_PESQUISAS_SATISFACAO, GET_PESQUISA_SATISFACAO_ESPECIFICA, GET_ALL_AUDIOS, GET_PESQUISA_USE } from './mutation-types'

export default {
  listarPesquisasSatisfacao: async ({ commit }) => {
    try {
      const response = await pesquisaSatisfacaoHttpService.getTodasPesquisasSatisfacao()
      commit(GET_ALL_PESQUISAS_SATISFACAO, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarPesquisaSatisfacaoEspecifica: async ({ commit }, id) => {
    try {
      const response = await pesquisaSatisfacaoHttpService.getPesquisaSatisfacaoIndividual(id)
      commit(GET_PESQUISA_SATISFACAO_ESPECIFICA, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarPesquisaUse: async ({ commit }, id) => {
    try {
      const response = await pesquisaSatisfacaoHttpService.getPesquisaUse(id)
      commit(GET_PESQUISA_USE, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarAudios: async ({ commit }) => {
    try {
      const response = await pesquisaSatisfacaoHttpService.getAudios()
      commit(GET_ALL_AUDIOS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
